module.exports = __webpack_public_path__ + "img/tree-03-c-trunk.14d6f17b.png";